enum ActiveValues {
  All = 'all',
  New = 'new',
  ShortList = 'shortlisted',
  OfferSent = 'offerSent',
  requestInterview = 'requestInterview',
}

export default ActiveValues;
